/* istanbul ignore file */

class UnauthorizedException extends Error {
  public unauthorized = true;
}

export default UnauthorizedException;
